export enum Route {
  MAIN_SCREEN = "main",
  SETTINGS_SCREEN = "settings",
  NOT_FOUND = "not_found",
}
